<app-base-modal modalName="mtpl-confirm-modal"
                [inProcessModal]="inProcessModal"
                [customCloseAction]="closeModal.bind(this)"
                [hideClose]="false">
    <ng-template>
        <div id="confirm-modal-container" class="confirm-modal-container">
            <div class="title-container">
                <div class="title-section">
                    {{ s.continueWithoutSaving }}
                </div>
                <div class="sub-title-section">
                    {{ s.selectSave }}
                </div>
            </div>
            <div class="button-container">
                <button class="app-submit-btn"
                    (click)="saveInputs()">
                        {{ s.saveInputs }}
                </button>
                <button class="app-submit-btn-secondary"
                    (click)="contiunueWithoutSave()">
                        {{ s.continueWithout }}
                </button>
            </div>
        </div>
    </ng-template>
</app-base-modal>